<template>
  <section>
    <div style="display: none">
      <div id="report_holder"></div>
    </div>

    <div v-show="pagetype == 1 || pagetype == 2">
      <el-form :inline="true">
        <el-form-item label="任务单号">
          <el-input v-model="filters.key" placeholder="任务单号" @change="getProdOutMaster(1)"></el-input>
        </el-form-item>
        <el-form-item label="发货单号">
          <el-input v-model="filters.code" placeholder="发货单号"></el-input>
        </el-form-item>
        <el-form-item label="工控机单号">
          <el-input v-model="filters.plcCode" placeholder="工控机单号"></el-input>
        </el-form-item>
        <el-form-item label="工程名称">
          <el-input v-model="filters.projectName" placeholder="工程名称"></el-input>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="filters.clientName" placeholder="客户名称"></el-input>
        </el-form-item>
        <el-form-item label="施工部位">
          <el-input v-model="filters.projectPart" placeholder="施工部位"></el-input>
        </el-form-item>
        <el-form-item label="浇筑方式">
          <el-input v-model="filters.pouringMethodName" placeholder="浇筑方式"></el-input>
        </el-form-item>
        <el-form-item label="车号">
          <el-input v-model="filters.vehicleErpCode" placeholder="车号" @change="getProdOutMaster(1)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker type="datetime" placeholder="开始日期" v-model="filters.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <el-date-picker type="datetime" placeholder="结束日期" v-model="filters.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.orgCode" filterable placeholder="请选择" @change="getProdOutMaster(1)">
            <el-option v-for="item in orgList" :key="item.OrgCode + 'Seach'" :label="item.Name"
              v-model="item.OrgCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getProdOutMaster(1)">
            查询
          </el-button>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="prodOutMaster" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" :border="true">
      <el-table-column prop="ClientName" label="出货单号" width="210">
        <template slot-scope="scope">
          <div>
            <el-link type="primary" @click="handleDetail(scope.row)">
              <el-tag :type="scope.row.ItemType == 0
                ? 'success'
                : scope.row.ItemType == 100
                  ? 'info'
                  : scope.row.ItemType == 200
                    ? 'warning'
                    : ''
                ">
                {{
                  scope.row.ItemType == 0
                    ? "调度"
                    : scope.row.ItemType == 100
                      ? "补单"
                      : scope.row.ItemType == 200
                        ? "退转"
                        : ""
                }}
              </el-tag>
              {{ scope.row.Code }}
            </el-link>
          </div>
          <div>{{ scope.row.ProductionTime }}</div>
          <div>{{ scope.row.StationLineName }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="TaskCode" label="工程信息">
        <template slot-scope="scope">
          <div>{{ scope.row.ProjectName }}</div>
          <div>
            施工部位：
            <span class="table-value">{{ scope.row.ProjectPart }}</span>
            浇筑方式：
            <span class="table-value">{{ scope.row.PouringMethodName }}</span>
          </div>
          <div>
            强度等级：
            <span class="table-value">{{ scope.row.GradeName }}</span>
            特殊材料：
            <span class="table-value">{{ scope.row.SpecMtlName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ProjectName" label="方量信息">
        <template slot-scope="scope">
          <div>
            发货：
            <span class="table-value">{{ scope.row.QuantityDelivery }}</span>
            签收：
            <span class="table-value">{{ scope.row.SigningQuantity }}</span>
          </div>
          <div>
            混凝土：
            <span class="table-value">{{ scope.row.TQuantity }}</span>
            砂浆：
            <span class="table-value">{{ scope.row.SQuantity }}</span>
          </div>
          <div>
            累计方量：
            <span class="table-value">{{ scope.row.QuantityTotal }}</span>
            <span v-if="canShowPrice">单价：</span>
            <span class="table-value" v-if="canShowPrice">
              {{ scope.row.Price }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="车辆信息">
        <template slot-scope="scope">
          <div>
            车号司机：
            <span class="table-value">
              {{ scope.row.VehicleErpCode }} {{ scope.row.DriverName }}
            </span>
          </div>
          <div>
            累计车次：
            <span class="table-value">{{ scope.row.VehiclesTotal }}</span>
          </div>
          <div>
            任务单号：
            <span class="table-value">{{ scope.row.TaskCode }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.Status < 900 && pagetype != 2" @click="() => {
            currentRow = scope.row;
            handlSigning();
          }
          ">
            签收
          </el-link>
          <el-link type="primary" v-if="scope.row.Status < 900" @click="() => {
            currentRow = scope.row;
            handleEdit();
          }
          ">
            编辑
          </el-link>
          <el-link type="danger" v-if="scope.row.Status < 500 && pagetype != 2" @click="() => {
            sels.push(scope.row);
            handleDel();
          }
          ">
            删除
          </el-link>
          <el-link type="primary" @click="() => {
            currentRow = scope.row;
            getManufacture();
          }
          ">
            耗料
          </el-link>
          <el-link type="primary" @click="() => {
            currentRow = scope.row;
            print();
          }
          ">
            打印[{{ scope.row.PrintCount }}]
          </el-link>
          <el-link type="primary" v-if="scope.row.Status < 900 && pagetype != 2" @click="() => {
            currentRow = scope.row;
            handlTransfer();
          }
          ">
            退转料
          </el-link>
          <el-link type="primary" v-if="scope.row.Status < 900 && pagetype != 2" @click="() => {
            currentRow = scope.row;
            handlTransferHistry();
          }
          ">
            [历]
          </el-link>
          <el-link type="primary" v-if="scope.row.Status < 200 && pagetype == 2" @click="() => {
            currentRow = scope.row;
            handleComplete(false);
          }
          ">
            完成
          </el-link>
          <el-link type="primary" v-if="scope.row.Status < 200 && pagetype == 2" @click="() => {
            currentRow = scope.row;
            handleComplete(true);
          }
          ">
            完成并打印
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
    <!-- 签收 -->
    <el-dialog title="签收" width="90%" :visible.sync="singeFormVisible" v-model="singeFormVisible" append-to-body
      :close-on-click-modal="false">
      <el-form :model="singeForm" label-width="120px" :rules="singeFormRules" ref="singeForm">
        <el-divider content-position="left">出货单信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input v-model="singeForm.ClientName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本车车号">
              <el-input v-model="singeForm.VehicleErpCode" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工程名称">
              <el-input v-model="singeForm.ProjectName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本车司机">
              <el-input v-model="singeForm.DriverName" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="发货方量">
              <el-input v-model="singeForm.QuantityDelivery" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产方量">
              <el-input v-model="singeForm.TQuantity" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="砂浆方量">
              <el-input v-model="singeForm.SQuantity" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="强度等级">
              <el-input v-model="singeForm.GradeName" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="签收方量">
          <el-input v-model="singeForm.SigningQuantity"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="singeForm.Remark"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="上车超时备注">
              <el-input v-model="singeForm.SignOverRemark"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="超时时间">
              <el-input v-model="singeForm.SignOverTime" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="singeFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="singeSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>
    <!--新增编辑界面-->
    <el-dialog width="90%" :title="isEdit ? '修改' : '新增'" :visible.sync="addFormVisible" v-model="addFormVisible"
      append-to-body :close-on-click-modal="false">
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm" style="height: 350px">
        <div style="height: 350px; overflow: auto">
          <el-row>
            <el-col :span="12">
              <el-form-item label="生产时间" prop="ProductionTime">
                <el-date-picker v-model="addForm.ProductionTime" type="datetime" placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回站时间">
                <el-date-picker v-model="addForm.BackTime" type="datetime" placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="生产线" prop="StationLineName">
                <el-select v-model="addForm.StationLineID" placeholder="请选择" @change="selectStation">
                  <el-option v-for="item in stationLine" :key="item.Id + '_station'" :label="item.Name"
                    v-model="item.Id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="搅拌站">
                <template>
                  <el-select v-model="addForm.OrgID" filterable placeholder="请选择" @change="selectOrg">
                    <el-option v-for="item in orgList" :key="item.Id + '_jbz'" :label="item.Name"
                      v-model="item.Id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="任务选择" prop="ProjectName">
            <el-input v-model="addForm.TaskCode" readonly class="input-select" />
            <el-button type="primary" @click="visibleDialog = true" :loading="listLoading">
              选择
            </el-button>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户名称">
                <el-input v-model="addForm.ClientName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工程名称">
                <el-input v-model="addForm.ProjectName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="施工部位" prop="ProjectPart">
                <el-input v-model="addForm.ProjectPart"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="施工单位">
                <el-input v-model="addForm.ProjectCmpy"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="施工地址">
                <el-input v-model="addForm.ProejctAddress"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="票据类别" prop="BillType">
                <el-select v-model="addForm.BillType" placeholder="请选择类别">
                  <el-option label="送料" :value="0"></el-option>
                  <el-option label="砂浆" :value="100"></el-option>
                  <el-option label="拉水" :value="200"></el-option>
                  <el-option label="补方" :value="300"></el-option>
                  <el-option label="其他" :value="400"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="打印抬头">
            <el-input v-model="addForm.PrintTitle"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="发货方量">
                <el-input v-model="addForm.QuantityDelivery"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="混凝土方量">
                <el-input v-model="addForm.TQuantity" @input="changequantity"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="砂浆方量">
                <el-input v-model="addForm.SQuantity" @input="changequantity"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="特殊材料">
            <el-checkbox-group v-model="specMtlIDList">
              <el-checkbox v-for="item in baseData.SpecialMaterialList" :label="item.Id" :key="item.Id + '_ts'"
                @change="changeSpecialMaterial(item, $event)">
                {{ item.Name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="强度等级" prop="GradeName">
                <template>
                  <el-select v-model="addForm.GradeID" filterable placeholder="请选择" @change="selectGrade">
                    <el-option v-for="item in baseData.GradeList" :key="item.Id + '_qd'" :label="item.Name"
                      v-model="item.Id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="浇筑方式">
                <template>
                  <el-select v-model="addForm.PouringMethodID" filterable placeholder="请选择"
                    @change="selectPouringMethod">
                    <el-option v-for="item in baseData.PouringMethodList" :key="item.Id + '_jz'" :label="item.Name"
                      v-model="item.Id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="坍落度">
                <template>
                  <el-select v-model="addForm.TLD" filterable placeholder="请选择" @change="selectTld">
                    <el-option v-for="item in baseData.TldList" :key="item.Id + '_tld'" :label="item.Name"
                      v-model="item.Id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注">
            <el-input v-model="addForm.Remark"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人">
                <el-input v-model="addForm.ContactsName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话">
                <el-input v-model="addForm.ContactsPhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="运输距离">
            <el-input v-model="addForm.Distance"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="司机选择" prop="DriverName">
                <el-input v-model="addForm.DriverName" readonly>
                  <template slot="append">
                    <el-button class="pd-5" type="primary" @click="hrvisibleDialog = true">
                      选择
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆选择" prop="VehicleErpCode">
                <el-input v-model="addForm.VehicleErpCode" readonly>
                  <template slot="append">
                    <el-button class="pd-5" @click="vevisibleDialog = true">
                      选择
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="操作员选择" prop="OperatorName">
                <el-input v-model="addForm.OperatorName" readonly>
                  <template slot="append">
                    <el-button class="pd-5" @click="opvisibleDialog = true">
                      选择
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="泵送司机选择" prop="PumpingDriverName">
                <el-input v-model="addForm.PumpingDriverName" readonly>
                  <template slot="append">
                    <el-button class="pd-5" @click="puvisibleDialog = true">
                      选择
                    </el-button>
                    <el-button class="pd-5" @click="clearaPumpingDriverName">
                      清除
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 耗料详情 -->
    <el-dialog title="耗料详情" width="90%" :visible.sync="manufactureFormVisible" v-model="manufactureFormVisible"
      :close-on-click-modal="false" append-to-body>
      <el-button type="primary" @click="handlePrints('print')">打印</el-button>
      <el-button type="primary" @click="downReport('print')">导出</el-button>
      <el-button type="primary" @click="printProdmanufacture()">
        模板打印
      </el-button>
      <div id="print">
        <table class="table-bordered">
          <tr>
            <th>出货单号</th>
            <td>{{ manufactureMaster.Code }}</td>
            <th>生产时间</th>
            <td>{{ manufactureMaster.ProductionTime }}</td>
            <th>回站时间</th>
            <td>{{ manufactureMaster.BackTime }}</td>
          </tr>
          <tr>
            <th>任务名称</th>
            <td>{{ manufactureMaster.TaskCode }}</td>
            <th>施工配比</th>
            <td>{{ manufactureMaster.RecipeCode }}</td>
            <th>合同编号</th>
            <td>{{ manufactureMaster.ContractCode }}</td>
          </tr>
          <tr>
            <th>客户名称</th>
            <td colspan="2">{{ manufactureMaster.ClientName }}</td>
            <th>施工配比</th>
            <td colspan="2">{{ manufactureMaster.ProjectName }}</td>
          </tr>
          <tr>
            <th>工程地址</th>
            <td colspan="2">{{ manufactureMaster.ProejctAddress }}</td>
            <th>票据类别</th>
            <td colspan="2">
              {{
                manufactureMaster.BillType == 0
                  ? "送料"
                  : manufactureMaster.BillType == 100
                    ? "砂浆"
                    : manufactureMaster.BillType == 200
                      ? "拉水"
                      : manufactureMaster.BillType == 300
                        ? "补方"
                        : manufactureMaster.BillType == 400
                          ? "其他"
                          : "未定义"
              }}
            </td>
          </tr>
          <tr>
            <th>施工单位</th>
            <td colspan="2">{{ manufactureMaster.ProjectCmpy }}</td>
            <th>施工部位</th>
            <td colspan="2">{{ manufactureMaster.ProjectPart }}</td>
          </tr>
          <tr>
            <th>强度等级</th>
            <td>{{ manufactureMaster.GradeName }}</td>
            <th>特殊材料</th>
            <td>{{ manufactureMaster.SpecMtlName }}</td>
            <th>浇筑方式</th>
            <td>{{ manufactureMaster.PouringMethodName }}</td>
          </tr>
          <tr>
            <th>发货方量</th>
            <td>{{ manufactureMaster.QuantityDelivery }}</td>
            <th>混凝土方量</th>
            <td>{{ manufactureMaster.TQuantity }}</td>
            <th>砂浆方量</th>
            <td>{{ manufactureMaster.SQuantity }}</td>
          </tr>
          <tr>
            <th>累计车次</th>
            <td>{{ manufactureMaster.VehiclesTotal }}</td>
            <th>累计方量</th>
            <td :colspan="canShowPrice ? 1 : 3">
              {{ manufactureMaster.QuantityTotal }}
            </td>
            <th v-if="canShowPrice">单价</th>
            <td v-if="canShowPrice">{{ manufactureMaster.Price }}</td>
          </tr>
          <tr>
            <th>司机</th>
            <td>{{ manufactureMaster.DriverName }}</td>
            <th>车号</th>
            <td>{{ manufactureMaster.VehicleErpCode }}</td>
            <th>运距</th>
            <td>{{ manufactureMaster.Distance }}</td>
          </tr>
          <tr>
            <th>备注</th>
            <td colspan="5">{{ manufactureMaster.Remark }}</td>
          </tr>
        </table>
        <div v-for="item in Prodmanufacturemains" :key="item.Prodmanufacturemain.Id">
          <el-divider content-position="left">
            第{{ item.Prodmanufacturemain.NowItemNum }}盘 -
            {{ item.Prodmanufacturemain.ItemQuantity }}方
          </el-divider>
          <el-table :data="item.Prodmanufacturesubs" border :summary-method="getSummaries" show-summary
            style="width: 100%">
            <el-table-column prop="MatName" label="物资名称"></el-table-column>
            <el-table-column prop="MatGrade" label="物资规格"></el-table-column>
            <el-table-column prop="WarehouseName" label="仓库"></el-table-column>
            <el-table-column prop="Quantity" label="理论用量"></el-table-column>
            <el-table-column prop="ActualQuantity" label="实际用量"></el-table-column>
            <el-table-column prop="QuantityRate" label="误差率%"></el-table-column>
          </el-table>
        </div>
        <table class="table-bordered">
          <tr>
            <th>容重(理论)实际</th>
            <td>
              {{ ProdRecipeMain.QuantityRecipeSum }}/{{
                ProdRecipeMain.QuantityActualSum
              }}kg
            </td>
            <th>砂率</th>
            <td>{{ ProdRecipeMain.ProdRecipe.TSL }}%</td>
            <th>水胶比</th>
            <td>{{ ProdRecipeMain.ProdRecipe.TSJB }}</td>
          </tr>
          <tr>
            <th>F掺量</th>
            <td>{{ ProdRecipeMain.ProdRecipe.TFProportion }}</td>
            <th>K掺量</th>
            <td>{{ ProdRecipeMain.ProdRecipe.TKProportion }}</td>
            <th>A掺量</th>
            <td>{{ ProdRecipeMain.ProdRecipe.TAProportion }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>

    <!-- 退转料 -->
    <el-dialog title="退转料" :visible.sync="transferFormVisible" v-model="transferFormVisible" append-to-body
      :close-on-click-modal="false" width="90%">
      <el-form :model="oldProdOutMasterForm" label-width="120px" :rules="transferFormRules" ref="oldProdOutMasterForm">
        <el-divider content-position="left">出货单信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input v-model="oldProdOutMasterForm.ClientName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本车车号">
              <el-input v-model="oldProdOutMasterForm.VehicleErpCode" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工程名称">
              <el-input v-model="oldProdOutMasterForm.ProjectName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本车司机">
              <el-input v-model="oldProdOutMasterForm.DriverName" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="发货方量">
              <el-input v-model="oldProdOutMasterForm.QuantityDelivery"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产方量">
              <el-input v-model="oldProdOutMasterForm.TQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签收方量">
              <el-input v-model="oldProdOutMasterForm.SigningQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="强度等级">
              <el-input v-model="oldProdOutMasterForm.GradeName" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">退转料信息</el-divider>
        <el-row>
          <el-col :span="24">
            <el-form-item label="转料类型">
              <template>
                <el-radio-group v-model="returandtransferrecord.ReturnType">
                  <el-radio :label="0">盘盈转料</el-radio>
                  <el-radio :label="100">废料</el-radio>
                  <el-radio :label="200">整车转料</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="本次退转方量">
              <el-input v-model="returandtransferrecord.RemainQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="盘盈方量">
              <el-input v-model="returandtransferrecord.PYQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="车辆剩余方量">
              <el-input v-model="returandtransferrecord.Quantity"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="退转备注">
              <el-input v-model="returandtransferrecord.Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="单据处理">
              <template>
                        
                <el-radio-group v-model="returandtransferrecord.ToType">
                  <el-radio :label="0">转入车辆</el-radio>
                  <el-radio :label="100">生成出货单</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="returandtransferrecord.ToType == 100">
          <el-col :span="12">
            <el-form-item label="任务选择" prop="ProjectName">
              <el-input v-model="newProdOutMasterForm.TaskCode" readonly>
                <template slot="append">
                  <el-button class="pd-5" type="primary" @click="tzlvisibleDialog = true" :loading="listLoading">
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="returandtransferrecord.ToType == 100">
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input v-model="newProdOutMasterForm.ClientName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工程名称">
              <el-input v-model="newProdOutMasterForm.ProjectName" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="司机选择" prop="DriverName">
              <el-input v-model="newProdOutMasterForm.DriverName" readonly class="hr-select">
                <template slot="append">
                  <el-button class="pd-5" type="primary" @click="tzlhrvisibleDialog = true">
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车辆选择" prop="VehicleErpCode">
              <el-input v-model="newProdOutMasterForm.VehicleErpCode" readonly class="hr-select">
                <template slot="append">
                  <el-button class="pd-5" @click="tzlvevisibleDialog = true">
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="transferFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="transferSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog width="90%" title="详情" :visible.sync="isShowDetail" v-model="isShowDetail" :close-on-click-modal="false"
      append-to-body>
      <table class="table-bordered">
        <tr>
          <th>出货单号</th>
          <td>{{ DetailOutMaster.Code }}</td>
          <th>生产时间</th>
          <td>{{ DetailOutMaster.ProductionTime }}</td>
          <th>回站时间</th>
          <td>{{ DetailOutMaster.BackTime }}</td>
        </tr>
        <tr>
          <th>任务名称</th>
          <td>{{ DetailOutMaster.TaskCode }}</td>
          <th>施工配比</th>
          <td>{{ DetailOutMaster.RecipeCode }}</td>
          <th>合同编号</th>
          <td>{{ DetailOutMaster.ContractCode }}</td>
        </tr>
        <tr>
          <th>客户名称</th>
          <td colspan="2">{{ DetailOutMaster.ClientName }}</td>
          <th>工程名称</th>
          <td colspan="2">{{ DetailOutMaster.ProjectName }}</td>
        </tr>
        <tr>
          <th>工程地址</th>
          <td colspan="2">{{ DetailOutMaster.ProejctAddress }}</td>
          <th>票据类别</th>
          <td colspan="2">
            {{
              DetailOutMaster.BillType == 0
                ? "送料"
                : DetailOutMaster.BillType == 100
                  ? "砂浆"
                  : DetailOutMaster.BillType == 200
                    ? "拉水"
                    : DetailOutMaster.BillType == 300
                      ? "补方"
                      : DetailOutMaster.BillType == 400
                        ? "其他"
                        : "未定义"
            }}
          </td>
        </tr>
        <tr>
          <th>施工单位</th>
          <td colspan="2">{{ DetailOutMaster.ProjectCmpy }}</td>
          <th>施工部位</th>
          <td colspan="2">{{ DetailOutMaster.ProjectPart }}</td>
        </tr>
        <tr>
          <th>强度等级</th>
          <td>{{ DetailOutMaster.GradeName }}</td>
          <th>特殊材料</th>
          <td>{{ DetailOutMaster.SpecMtlName }}</td>
          <th>浇筑方式</th>
          <td>{{ DetailOutMaster.PouringMethodName }}</td>
        </tr>
        <tr>
          <th>发货方量</th>
          <td>{{ DetailOutMaster.QuantityDelivery }}</td>
          <th>混凝土方量</th>
          <td>{{ DetailOutMaster.TQuantity }}</td>
          <th>砂浆方量</th>
          <td>{{ DetailOutMaster.SQuantity }}</td>
        </tr>
        <tr>
          <th>累计车次</th>
          <td>{{ DetailOutMaster.VehiclesTotal }}</td>
          <th>累计方量</th>
          <td :colspan="canShowPrice ? 1 : 3">
            {{ DetailOutMaster.QuantityTotal }}
          </td>
          <th v-if="canShowPrice">单价</th>
          <td v-if="canShowPrice">{{ DetailOutMaster.Price }}</td>
        </tr>
        <tr>
          <th>司机</th>
          <td>{{ DetailOutMaster.DriverName }}</td>
          <th>车号</th>
          <td>{{ DetailOutMaster.VehicleErpCode }}</td>
          <th>运距</th>
          <td>{{ DetailOutMaster.Distance }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ DetailOutMaster.Remark }}</td>
        </tr>
      </table>
    </el-dialog>

    <!-- 退转料详情 -->
    <el-dialog title="退转料历史" width="90%" :visible.sync="transferHistryShow" v-model="transferHistryShow"
      :close-on-click-modal="false" append-to-body>
      <!--列表-->
      <el-table :data="transferList" highlight-current-row style="width: 100%">
        <el-table-column prop="OldOutMasterCode" label="原出货单" sortable width="150"></el-table-column>
        <el-table-column prop="NewOutMasterCode" label="新出货单" sortable width="150"></el-table-column>
        <el-table-column prop="VehicleErpCode" label="操作车辆" sortable></el-table-column>
        <el-table-column prop="RemainQuantity" label="退转方量" sortable></el-table-column>
        <el-table-column prop="Quantity" label="车辆剩余" sortable></el-table-column>
        <el-table-column prop="PYQuantity" label="盘盈方量" sortable></el-table-column>
        <el-table-column prop="ToType" label="转入类型" width="" sortable>
          <template slot-scope="scope">
            <el-tag :type="scope.row.ToType == 0 ? 'success' : 'info'" disable-transitions>
              {{ scope.row.ToType == 0 ? "转入车辆" : "转入出货单" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ReturnType" label="转料类型" width="" sortable>
          <template slot-scope="scope">
            <el-tag :type="scope.row.ReturnType == 0 ? 'success' : 'info'" disable-transitions>
              {{
                scope.row.ReturnType == 0
                  ? "盘盈转料"
                  : scope.row.ReturnType == 200
                    ? "整车转料"
                    : "废料"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" sortable></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" :formatter="formatDate" sortable></el-table-column>
        <el-table-column prop="CreateUser" label="创建者" sortable></el-table-column>
      </el-table>
    </el-dialog>

    <TableDataDialog title="任务选择" :visibleDialog="visibleDialog" :queryMethod="queryData" :columns="{
      Code: {
        label: '任务单号',
      },
      ClientName: {
        label: '客户名称',
      },
      ProjectName: {
        label: '工程名称',
      },
      ProjectPart: {
        label: '施工部位',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建人',
      },
    }" @getDialogVisible="setVisible" @callback="dialogCallback"></TableDataDialog>

    <TableDataDialog title="司机选择" :visibleDialog="hrvisibleDialog" :queryMethod="hrqueryData" :columns="{
      Name: {
        label: '姓名',
      },
      Code: {
        label: '工号',
      },
      Remark: {
        label: '备注',
      },
      WorkStatus: {
        label: '在职状态',
        filter: (item) => {
          return item.WorkStatus == 0
            ? '实习'
            : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
                ? '正式'
                : item.WorkStatus == 3
                  ? '临时'
                  : item.WorkStatus == 4
                    ? '离职'
                    : '退休';
        },
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="hrsetVisible" @callback="hrdialogCallback"></TableDataDialog>

    <TableDataDialog title="操作员选择" :visibleDialog="opvisibleDialog" :queryMethod="opqueryData" :columns="{
      Name: {
        label: '姓名',
      },
      Code: {
        label: '工号',
      },
      Remark: {
        label: '备注',
      },
      WorkStatus: {
        label: '在职状态',
        filter: (item) => {
          return item.WorkStatus == 0
            ? '实习'
            : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
                ? '正式'
                : item.WorkStatus == 3
                  ? '临时'
                  : item.WorkStatus == 4
                    ? '离职'
                    : '退休';
        },
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="opsetVisible" @callback="opdialogCallback"></TableDataDialog>

    <TableDataDialog title="泵车司机选择" :visibleDialog="puvisibleDialog" :queryMethod="puqueryData" :columns="{
      Name: {
        label: '姓名',
      },
      Code: {
        label: '工号',
      },
      Remark: {
        label: '备注',
      },
      WorkStatus: {
        label: '在职状态',
        filter: (item) => {
          return item.WorkStatus == 0
            ? '实习'
            : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
                ? '正式'
                : item.WorkStatus == 3
                  ? '临时'
                  : item.WorkStatus == 4
                    ? '离职'
                    : '退休';
        },
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="pusetVisible" @callback="pudialogCallback"></TableDataDialog>

    <TableDataDialog title="车辆选择" :visibleDialog="vevisibleDialog" :queryMethod="vequeryData" :columns="{
      Name: {
        label: '设备名称',
      },
      ErpCode: {
        label: '自编号',
      },
      License: {
        label: '车牌号',
      },
      Code: {
        label: '编号',
      },
      CarStatus: {
        label: '设备状态',
        filter: (item) => {
          return item.CarStatus == 0
            ? '待排'
            : item.CarStatus == 100
              ? '停用'
              : item.CarStatus == 200
                ? '维修'
                : item.CarStatus == 300
                  ? '排队接料中'
                  : item.CarStatus == 400
                    ? '运输途中'
                    : '未定义';
        },
      },
      CarType: {
        label: '车辆类型',
        filter: (item) => {
          return item.CarType == 0
            ? '搅拌车'
            : item.CarType == 100
              ? '泵车'
              : '其他类型';
        },
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="vesetVisible" @callback="vedialogCallback"></TableDataDialog>

    <!-- 任务选择-退转料 -->
    <TableDataDialog title="任务选择" :visibleDialog="tzlvisibleDialog" :queryMethod="tzlqueryData" :columns="{
      Code: {
        label: '任务编号',
      },
      ClientName: {
        label: '客户名称',
      },
      ProjectName: {
        label: '工程名称',
      },

      ProjectPart: {
        label: '施工部位',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建人',
      },
    }" @getDialogVisible="tzlsetVisible" @callback="tzldialogCallback"></TableDataDialog>

    <TableDataDialog title="车辆选择" :visibleDialog="tzlvevisibleDialog" :queryMethod="tzlvequeryData" :columns="{
      Name: {
        label: '设备名称',
      },
      ErpCode: {
        label: '自编号',
      },
      License: {
        label: '车牌号',
      },
      Code: {
        label: '编号',
      },
      CarStatus: {
        label: '设备状态',
        filter: (item) => {
          return item.CarStatus == 0
            ? '待排'
            : item.CarStatus == 100
              ? '停用'
              : item.CarStatus == 200
                ? '维修'
                : item.CarStatus == 300
                  ? '排队接料中'
                  : item.CarStatus == 400
                    ? '运输途中'
                    : '未定义';
        },
      },
      CarType: {
        label: '车辆类型',
        filter: (item) => {
          return item.CarType == 0
            ? '搅拌车'
            : item.CarType == 100
              ? '泵车'
              : '其他类型';
        },
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="tzlcarVisible" @callback="tzlvcallback"></TableDataDialog>

    <TableDataDialog title="司机选择" :visibleDialog="tzlhrvisibleDialog" :queryMethod="tzlhrqueryData" :columns="{
      Name: {
        label: '姓名',
      },
      Code: {
        label: '工号',
      },
      Remark: {
        label: '备注',
      },
      WorkStatus: {
        label: '在职状态',
        filter: (item) => {
          return item.WorkStatus == 0
            ? '实习'
            : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
                ? '正式'
                : item.WorkStatus == 3
                  ? '临时'
                  : item.WorkStatus == 4
                    ? '离职'
                    : '退休';
        },
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="tzlhrsetVisible" @callback="tzlhrdialogCallback"></TableDataDialog>
  </section>
</template>

<script>
//引入ProdOutMaster.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../api/prodoutmaster";
import { getButtonList } from "../promissionRouter";
import Toolbar from "../components/Toolbar";
import TableDataDialog from "../components/TableDataDialog";
import { getProdTaskListPage } from "../api/prodTask";
import { getSysStationLineListPage } from "../api/recipe";
import { getHrEmployeeListPage } from "../api/hrEmployee";
import { getVehicleListPage, getVehicleDetail } from "../api/vehicle";
import printJS from "print-js";
import { runReport } from "../api/viewReport";
import { mapGetters } from "vuex";
import { DownExportExcel } from "../api/command";
export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        key: "",
        code: "",
        plcCode: "",
        clientName: "",
        projectName: "",
        projectPart: "",
        pouringMethodName: "",
        vehicleErpCode: "",
        startTime: "",
        endTime: "",
      },
      prodOutMaster: [],
      baseData: [], //任务单基础数据
      specMtlIDList: [],
      specMtlName: [],
      specMtlID: [],
      orgList: [],
      stationLine: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        VehicleErpCode: [
          { required: true, message: "请选择车辆", trigger: "blur" },
        ],
        GradeName: [
          { required: true, message: "请选择强度等级", trigger: "blur" },
        ],
        ProjectPart: [
          { required: true, message: "请输入施工部位", trigger: "blur" },
        ],
        ProjectName: [
          { required: true, message: "请选择任务", trigger: "blur" },
        ],
        StationLineName: [
          { required: true, message: "请选择生产线", trigger: "blur" },
        ],
        ProductionTime: [
          {
            required: true,
            message: "请选择生产时间",
            trigger: "date",
          },
        ],
      },
      singeFormRules: {
        //Name: [{ required: true, message: "请输入物资名称", trigger: "blur" }],
      },
      transferFormRules: {},
      //新增编辑数据
      addForm: {},
      visibleDialog: false, //任务单列表选择
      hrvisibleDialog: false, //司机列表选择
      opvisibleDialog: false, //操作员列表选择
      puvisibleDialog: false, //泵车司机列表选择
      vevisibleDialog: false, //车辆列表选择
      isEdit: false, //是否为编辑 true为编辑 默认新增
      singeFormVisible: false,
      singeForm: {},
      Prodmanufacturemains: [
        {
          Prodmanufacturemain: {},
          Prodmanufacturesubs: [],
        },
      ],
      ProdRecipeMain: {
        ProdRecipe: {
          TSL: 0,
          TSJB: 0,
          TFProportion: 0,
          TKProportion: 0,
          TAProportion: 0,
        },
        prodRecipeSubs: [],
        QuantityRecipeSum: 0,
        QuantityActualSum: 0,
      },
      manufactureFormVisible: false,
      manufactureMaster: {},
      isShowDetail: false,
      DetailOutMaster: {},
      transferFormVisible: false, //退转料
      oldProdOutMasterForm: {}, //退转料原出货单
      newProdOutMasterForm: {}, //退转料新出货单
      returandtransferrecord: { ReturnType: 0, ToType: 0 }, //退转料实体
      tzlvisibleDialog: false,
      tzlvevisibleDialog: false,
      tzlhrvisibleDialog: false,
      transferHistryShow: false, //退转料历史是否显示
      transferList: [], //退转料历史列表
      orgId: "",
      orgCode: "",
      orgName: "",
      outmasterAuto: null, //轮询查询
    };
  },
  //type=1 则为出货单页面 为2则为历史出货单
  props: ["pagetype", "pagecode"],
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex(
        (s) => s.name === "编辑" || s.name === "修改"
      );
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
    canShowPrice() {
      let index = this.buttonList.findIndex((s) => s.name === "查看单价");
      return index > -1;
    },
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = Number(values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Number(prev + curr);
            } else {
              return prev;
            }
          }, 0)).toFixed(2);
          if (index == columns.length - 1) {
            sums[index] =
              sums[2] > 0
                ? (Number((sums[3] - sums[2]) / sums[2]) * 100).toFixed(3)
                : 0;
          }
        } else {
        }
      });

      return sums;
    },
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getProdOutMaster();
    },
    //获取出货单
    getProdOutMaster(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      if (this.outmasterAuto) {
        clearTimeout(this.outmasterAuto);
      }
      let that = this;
      if (that && !that._isDestroyed) {
        let para = {
          page: this.page,
          vehicleErpCode: this.filters.vehicleErpCode,
          key: this.pagecode ? this.pagecode : this.filters.key,
          startTime: this.filters.startTime,
          endTime: this.filters.endTime,
          orgCode: this.filters.orgCode,
          intPageSize: this.pageSize,
          pagetype: this.pagetype,
          code: this.filters.code,
          projectName: this.filters.projectName,
          clientName: this.filters.clientName,
          projectPart: this.filters.projectPart,
          plcCode: this.filters.plcCode,
          pouringMethodName: this.filters.pouringMethodName,

        };
        this.listLoading = true;
        api
          .getProdOutMasterListPage(para)
          .then((res) => {
            this.total = res.data.response.dataCount;
            this.prodOutMaster = res.data.response.data;
            this.listLoading = false;
            this.sels = [];
          })
          .finally(() => {
            if (this.pagetype == 2) {
              //机楼车辆队列
              this.outmasterAuto = setTimeout(() => {
                this.getProdOutMaster();
              }, 5000);
            }
          });
      }
    },
    getBaseData() {
      api.getGetProdOutMasterBaseData().then((res) => {
        this.baseData = res.data.response;
      });
    },
    //获取生产线列表
    getSysStationLineList(orgId) {
      let para = {
        key: orgId,
      };
      this.listLoading = true;
      getSysStationLineListPage(para)
        .then((res) => {
          this.stationLine = res.data.response.data;
          if (res.data.response.data.length > 0) {
            this.addForm.StationLineID = this.stationLine[0].Id;
            this.addForm.StationLineName = this.stationLine[0].Name;
          } else {
            this.addForm.StationLineID = null;
            this.addForm.StationLineName = null;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteProdOutMaster(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getProdOutMaster();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示签收界面
    handlSigning() {
      this.singeFormVisible = true;
      let row = this.currentRow;
      if (row.SpecMtlID) {
        this.specMtlID = row.SpecMtlID.split(",");
      }
      if (row.SpecMtlName) {
        this.specMtlName = row.SpecMtlName.split(",");
      }

      this.specMtlIDList = this.specMtlID;
      this.singeForm = row;
    },

    //执行签收
    singeSubmit() {
      this.$refs.singeForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.singeForm);
          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          api
            .singeProdOutMaster(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["singeForm"].resetFields();
                this.singeFormVisible = false;
                this.getProdOutMaster();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    ///=改变用量时触发重算发货方量
    changequantity() {
      var tquantity =
        this.addForm.TQuantity == "" || this.addForm.TQuantity == undefined
          ? 0
          : Number(this.addForm.TQuantity);
      var squantity =
        this.addForm.SQuantity == "" || this.addForm.SQuantity == undefined
          ? 0
          : Number(this.addForm.SQuantity);
      this.addForm.QuantityDelivery = tquantity + squantity;
    },
    //显示退转料界面
    handlTransfer() {
      this.transferFormVisible = true;
      let row = this.currentRow;
      this.specMtlIDList = this.specMtlID;
      this.oldProdOutMasterForm = row;
      this.returandtransferrecord = {
        ReturnType: 0,
        ToType: 0,
        Quantity: 0,
        QuantityDelivery: row.QuantityDelivery,
        PYQuantity: 0,
      };
      this.newProdOutMasterForm = JSON.parse(JSON.stringify(row));
      //获取此车辆剩余方量
      let para = { Id: row.VehicleID };
      getVehicleDetail(para).then((res) => {
        this.returandtransferrecord.Quantity = res.data.response.RemainQuantity;
      });
    },
    handlTransferHistry() {
      this.transferHistryShow = true;
      let row = this.currentRow;
      let para = {
        key: row.Code,
      };
      api.getTransferHistry(para).then((res) => {
        this.transferList = res.data.response.data;
      });
    },
    //显示编辑界面
    handleEdit() {
      this.isEdit = true;
      this.addFormVisible = true;
      let row = this.currentRow;
      this.specMtlID = [];
      this.specMtlName = [];
      if (row.SpecMtlID && row.SpecMtlID.length > 0) {
        this.specMtlID = row.SpecMtlID.split(",");
      }
      if (row.SpecMtlName && row.SpecMtlName.length > 0) {
        this.specMtlName = row.SpecMtlName.split(",");
      }
      this.specMtlIDList = this.specMtlID;
      this.addForm = row;
    },
    //显示新增界面
    handleAdd() {
      this.isEdit = false;
      this.addFormVisible = true;
      this.addForm = {
        OrgID: this.orgId,
        OrgCode: this.orgCode,
        OrgName: this.orgName,
        TaskID: null,
        TaskCode: null,
        ProjectID: null,
        ProjectName: null,
        ClientID: null,
        ClientName: null,
        ProjectPart: null,
        GradeID: null,
        GradeName: null,
        ProjectCmpy: null,
        ProejctAddress: null,
        TLD: null,
        TLDID: null,
        PouringMethodName: null,
        PouringMethodID: null,
        ContactsName: null,
        ContactsPhone: null,
        VehicleErpCode: null,
      };
    },
    //执行新增/编辑
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            api
              .editProdOutMaster(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getProdOutMaster();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addLoading = false;
              });
          } else {
            api
              .addProdOutMaster(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getProdOutMaster();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addLoading = false;
              });
          }
        }
      });
    },
    //完成
    handleComplete(isPrint) {
      this.addLoading = true;
      this.currentRow.Status = 200; //200生产完成
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .putProdOutMaster(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            if (isPrint) {
              this.print();
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getProdOutMaster();
        })
        .finally(() => {
          this.addLoading = false;
        });
    },
    // 显示窗口
    handleDetail(row) {
      this.DetailOutMaster = row;
      this.isShowDetail = !this.isShowDetail;
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.getProdOutMaster();
    },
    dialogCallback(data) {
      if (data.length > 0) {
        this.addForm.TaskID = data[0].Id;
        this.addForm.TaskCode = data[0].Code;
        this.addForm.ProjectID = data[0].ProjectID;
        this.addForm.ProjectName = data[0].ProjectName;
        this.addForm.ClientID = data[0].ClientID;
        this.addForm.ClientName = data[0].ClientName;
        this.addForm.ProjectPart = data[0].ProjectPart;
        this.addForm.GradeID = data[0].GradeID;
        this.addForm.GradeName = data[0].GradeName;
        this.addForm.ProjectCmpy = data[0].ProjectCmpy;
        this.addForm.ProejctAddress = data[0].ConstructionAddress;
        this.addForm.TLD = data[0].TLD;
        this.addForm.TLDID = data[0].TLDID;
        this.addForm.PouringMethodName = data[0].WorkMethodName;
        this.addForm.PouringMethodID = data[0].WorkMethodID;
        this.addForm.ContactsName = data[0].ContactName;
        this.addForm.ContactsPhone = data[0].ContactPhone;
        if (data[0].SpecMtlID) {
          this.specMtlID = data[0].SpecMtlID.split(",");
          this.specMtlName = data[0].SpecMtlName.split(",");
          this.specMtlIDList = this.specMtlID;
        } else {
          this.specMtlID = [];
          this.specMtlName = [];
          this.specMtlIDList = [];
        }
      }
      this.visibleDialog = false;
    },
    queryData(params) {
      let taskparams = {
        page: params.page,
        key: params.key,
        intPageSize: params.intPageSize,
      };
      let curDate = new Date().getTime();
      let halfYear = (365 / 2) * 24 * 3600 * 1000;
      let pastResult = curDate - halfYear;
      let pastDate = new Date(pastResult),
        pastYear = pastDate.getFullYear(),
        pastMonth = pastDate.getMonth() + 1,
        pastDay = pastDate.getDate();
      taskparams.startTime = pastYear + "-" + pastMonth + "-" + pastDay;
      return getProdTaskListPage(taskparams);
    },
    setVisible(val) {
      this.visibleDialog = val;
    },
    /*退转料 */
    tzlhrdialogCallback(data) {
      if (data.length > 0) {
        this.newProdOutMasterForm.DriverID = data[0].Id;
        this.newProdOutMasterForm.DriverName = data[0].Name;
      }
      this.tzlhrvisibleDialog = false;
    },
    tzlhrqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    tzlhrsetVisible(val) {
      this.tzlhrvisibleDialog = val;
    },
    tzlvcallback(data) {
      if (data.length > 0) {
        this.newProdOutMasterForm.VehicleID = data[0].Id;
        this.newProdOutMasterForm.VehicleErpCode = data[0].ErpCode;
        this.returandtransferrecord.Quantity = data[0].RemainQuantity;
      }
      this.tzlvevisibleDialog = false;
    },
    tzlvequeryData(params) {
      return getVehicleListPage(params);
    },
    tzlcarVisible(val) {
      this.tzlvevisibleDialog = val;
    },
    tzldialogCallback(data) {
      if (data.length > 0) {
        this.newProdOutMasterForm.TaskID = data[0].Id;
        this.newProdOutMasterForm.TaskCode = data[0].Code;
        this.newProdOutMasterForm.ProjectID = data[0].ProjectID;
        this.newProdOutMasterForm.ProjectName = data[0].ProjectName;
        this.newProdOutMasterForm.ClientID = data[0].ClientID;
        this.newProdOutMasterForm.ClientName = data[0].ClientName;
        this.newProdOutMasterForm.ProjectPart = data[0].ProjectPart;
        this.newProdOutMasterForm.ProjectCmpy = data[0].ProjectCmpy;
      }
      this.tzlvisibleDialog = false;
    },
    tzlqueryData(params) {
      let taskparams = {
        page: params.page,
        key: params.key,
        intPageSize: params.intPageSize,
      };
      let curDate = new Date().getTime();
      let halfYear = (365 / 2) * 24 * 3600 * 1000;
      let pastResult = curDate - halfYear;
      let pastDate = new Date(pastResult),
        pastYear = pastDate.getFullYear(),
        pastMonth = pastDate.getMonth() + 1,
        pastDay = pastDate.getDate();
      taskparams.startTime = pastYear + "-" + pastMonth + "-" + pastDay;
      return getProdTaskListPage(taskparams);
    },
    tzlsetVisible(val) {
      this.tzlvisibleDialog = val;
    },
    transferSubmit() {
      this.$refs.oldProdOutMasterForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          this.newProdOutMasterForm.SigningQuantity = 0;
          this.newProdOutMasterForm.PlcSOutMasterCode = null;
          this.newProdOutMasterForm.PlcOutMasterCode = null;
          this.newProdOutMasterForm.ProductionTime = null;
          this.newProdOutMasterForm.BackTime = null;
          var dm = {
            NewProdOutMaster: this.newProdOutMasterForm,
            OldProdOutMaster: this.oldProdOutMasterForm,
            ReturAndTransferRecord: this.returandtransferrecord,
          };
          let para = Object.assign({}, dm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          api
            .SaveTransfer(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["oldProdOutMasterForm"].resetFields();
                this.transferFormVisible = false;
                this.getProdOutMaster();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    /*退转料 */
    hrdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.DriverID = data[0].Id;
        this.addForm.DriverName = data[0].Name;
      }
      this.hrvisibleDialog = false;
    },
    hrqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    hrsetVisible(val) {
      this.hrvisibleDialog = val;
    },
    opdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.OperatorID = data[0].Id;
        this.addForm.OperatorName = data[0].Name;
      }
      this.opvisibleDialog = false;
    },
    opqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    opsetVisible(val) {
      this.opvisibleDialog = val;
    },
    vedialogCallback(data) {
      if (data.length > 0) {
        this.addForm.VehicleID = data[0].Id;
        this.addForm.VehicleErpCode = data[0].ErpCode;
      }
      this.vevisibleDialog = false;
    },
    vequeryData(params) {
      return getVehicleListPage(params);
    },
    vesetVisible(val) {
      this.vevisibleDialog = val;
    },
    pudialogCallback(data) {
      if (data.length > 0) {
        this.addForm.PumpingDriverID = data[0].Id;
        this.addForm.PumpingDriverName = data[0].Name;
      }
      this.puvisibleDialog = false;
    },
    clearaPumpingDriverName() {
      this.addForm.PumpingDriverID = null;
      this.addForm.PumpingDriverName = null;
    },
    puqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    pusetVisible(val) {
      this.puvisibleDialog = val;
    },
    //强度等级改变时触发
    selectGrade(id) {
      var value = this.baseData.GradeList.filter((e) => e.Id == id)[0];
      this.addForm.GradeID = value.Id;
      this.addForm.GradeName = value.Name;
    },
    //组织机构改变时触发
    selectOrg(id) {
      this.addForm.OrgCode = this.orgList.filter((e) => e.Id == id)[0].OrgCode;
      this.addForm.OrgName = this.orgList.filter((e) => e.Id == id)[0].Nmae;
      this.addForm.OrgID = id;
      this.getSysStationLineList(id);
    },
    //坍落度改变时触发
    selectTld(id) {
      var value = this.baseData.TldList.filter((e) => e.Id == id)[0];
      this.addForm.TLD = value.Name;
      this.addForm.TLDID = value.id;
    },
    //浇筑方式改变时触发
    selectPouringMethod(id) {
      var value = this.baseData.PouringMethodList.filter((e) => e.Id == id)[0];
      this.addForm.PouringMethodID = value.Id;
      this.addForm.PouringMethodName = value.Name;
    },
    //特殊材料选择
    changeSpecialMaterial(value, isTrue) {
      if (isTrue) {
        this.specMtlID.push(value.Id);
        this.specMtlName.push(value.Name);
      } else {
        this.specMtlID.splice(
          this.specMtlID.findIndex((x) => x === value.Id),
          1
        );
        this.specMtlName.splice(
          this.specMtlName.findIndex((x) => x === value.Name),
          1
        );
      }
      this.addForm.SpecMtlID = this.specMtlID.toString();
      this.addForm.SpecMtlName = this.specMtlName.toString();
    },
    selectStation(id) {
      this.addForm.StationLineID = id;
      this.addForm.StationLineName = this.stationLine.filter(
        (e) => e.Id == id
      )[0].Name;
    },
    getManufacture() {
      this.manufactureFormVisible = true;
      let row = this.currentRow;
      this.manufactureMaster = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });

        return;
      }
      this.isEdit = true;
      let para = {
        outmasterCode: row.Code,
      };
      api.getManufactureDetail(para).then((res) => {
        this.listLoading = false;
        this.Prodmanufacturemains = res.data.response.Prodmanufacturemains;
        if (res.data.response.ProdRecipe) {
          this.ProdRecipeMain.ProdRecipe = res.data.response.ProdRecipe;
          this.ProdRecipeMain.ProdRecipeSubs = res.data.response.ProdRecipeSubs;
        }

        this.Prodmanufacturemains.map((e) => {
          var prodmanufacturesubs = [];
          e.Prodmanufacturesubs.map((k) => {
            var matGrade = '';
            if (this.ProdRecipeMain.ProdRecipeSubs && this.ProdRecipeMain.ProdRecipeSubs.length > 0) {
              var recipeSubItem = this.ProdRecipeMain.ProdRecipeSubs.filter(p => p.MatID == k.MatID);
              if (recipeSubItem && recipeSubItem.length > 0) {
                matGrade = recipeSubItem[0].MatGrade;
              }
            }

            prodmanufacturesubs.push({
              MatName: k.MatName,
              MatID: k.MatID,
              MatGrade: matGrade,
              WarehouseName: k.WarehouseName,
              WarehouseID: k.WarehouseID,
              Quantity: k.Quantity,
              ActualQuantity: k.ActualQuantity,
              QuantityRate:
                k.Quantity > 0
                  ? (
                    Number((k.ActualQuantity - k.Quantity) / k.Quantity) * 100
                  ).toFixed(3)
                  : 0,
            });
            this.ProdRecipeMain.QuantityRecipeSum += Number(k.Quantity);
            this.ProdRecipeMain.QuantityActualSum += Number(k.ActualQuantity);
            e.Prodmanufacturesubs = prodmanufacturesubs;
          });
        });
        this.ProdRecipeMain.QuantityRecipeSum = Number(this.ProdRecipeMain.QuantityRecipeSum).toFixed(2);
        this.ProdRecipeMain.QuantityActualSum = Number(this.ProdRecipeMain.QuantityActualSum).toFixed(2);

      });
    },
    print() {
      let row = this.currentRow;
      let para = {
        id: row.Id,
      };
      api.getPrintContent(para).then((res) => {
        this.listLoading = false;
        if (res.data.success) {
          runReport(
            res.data.response.PrintEntity,
            res.data.response.PrintModel
          );
          let syles = "";
          if (document.styleSheets.length > 1) {
            for (let i = document.styleSheets.length - 1; i > 0; i--) {
              if (document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0) {
                let rulesList = document.styleSheets[i].cssRules;
                for (let j = 0; j < rulesList.length; j++) {
                  syles += rulesList[j].cssText;
                }
                break;
              }
            }
          }
          printJS({
            printable: "report_holder",
            type: "html",
            header: null,
            targetStyles: ["*"],
            style: syles,
            scanStyles: false,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    printProdmanufacture() {
      let para = {
        outMasterId: this.manufactureMaster.Id,
      };
      api.getPrintProdmanufacture(para).then((res) => {
        this.listLoading = false;
        if (res.data.success) {
          runReport(
            res.data.response.PrintEntity,
            res.data.response.PrintModel
          );
          let syles = "";
          if (document.styleSheets.length > 1) {
            for (let i = document.styleSheets.length - 1; i > 0; i--) {
              if (document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0) {
                let rulesList = document.styleSheets[i].cssRules;
                for (let j = 0; j < rulesList.length; j++) {
                  syles += rulesList[j].cssText;
                }
                break;
              }
            }
          }
          printJS({
            printable: "report_holder",
            type: "html",
            header: null,
            targetStyles: ["*"],
            style: syles,
            scanStyles: false,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    downReport(id) {
      const html = document.querySelector("#" + id).innerHTML;
      // 新建一个 DOM
      const div = document.createElement("div");
      const printDOMID = "printDOMElement";
      div.id = printDOMID;
      div.innerHTML = html;

      // 提取第一个表格的内容 即表头
      const ths = div.querySelectorAll(".el-table__header-wrapper th");
      var ThsTextArry = [];
      for (let i = 0, len = ths.length; i < len; i++) {
        if (ths[i].innerText !== "") ThsTextArry.push(ths[i].innerText);
      }

      // 删除多余的表头
      div.querySelector(".hidden-columns").remove();
      // 第一个表格的内容提取出来后已经没用了 删掉
      div.querySelector(".el-table__header-wrapper").remove();
      ThsTextArry = this.unique(ThsTextArry);
      // 将第一个表格的内容插入到第二个表格
      let newHTML = "<tr>";
      for (let i = 0, len = ThsTextArry.length; i < len; i++) {
        newHTML +=
          '<td style="text-align: center; font-weight: bold">' +
          ThsTextArry[i] +
          "</td>";
      }

      newHTML += "</tr>";
      div
        .querySelector(".el-table__body-wrapper table")
        .insertAdjacentHTML("afterbegin", newHTML);
      // 将新的 DIV 添加到页面 打印后再删掉

      document.querySelector("body").appendChild(div);
      var htmlTxt = "<style>table {  width: 100% !important; border-collapse: collapse; border-spacing: 0; } table th{ line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: right;} table td{line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: left;}</style>" + div.innerHTML;
      div.remove();
      let para = { Html: htmlTxt, Name: "本车耗料" };
      var sheetName = "本车耗料";
      DownExportExcel(para, sheetName).then((res) => { });
    },
    /** 打印按钮操作 */
    handlePrints(id) {
      const html = document.querySelector("#" + id).innerHTML;
      // 新建一个 DOM
      const div = document.createElement("div");
      const printDOMID = "printDOMElement";
      div.id = printDOMID;
      div.innerHTML = html;

      // 提取第一个表格的内容 即表头
      const ths = div.querySelectorAll(".el-table__header-wrapper th");
      var ThsTextArry = [];
      for (let i = 0, len = ths.length; i < len; i++) {
        if (ths[i].innerText !== "") ThsTextArry.push(ths[i].innerText);
      }

      // 删除多余的表头
      div.querySelector(".hidden-columns").remove();
      // 第一个表格的内容提取出来后已经没用了 删掉
      div.querySelector(".el-table__header-wrapper").remove();
      ThsTextArry = this.unique(ThsTextArry);
      // 将第一个表格的内容插入到第二个表格
      let newHTML = "<tr>";
      for (let i = 0, len = ThsTextArry.length; i < len; i++) {
        newHTML +=
          '<td style="text-align: center; font-weight: bold">' +
          ThsTextArry[i] +
          "</td>";
      }

      newHTML += "</tr>";
      div
        .querySelector(".el-table__body-wrapper table")
        .insertAdjacentHTML("afterbegin", newHTML);
      // 将新的 DIV 添加到页面 打印后再删掉

      document.querySelector("body").appendChild(div);
      printJS({
        printable: printDOMID,
        type: "html",
        scanStyles: false,
        style:
          "table {  width: 100% !important; border-collapse: collapse; border-spacing: 0; } table th{ line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: right;} table td{line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: left;}", // 表格样式
      });

      div.remove();
    },
    unique(arr) {
      var res = [];
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i]]) {
          obj[arr[i]] = 1;
          res.push(arr[i]);
        }
      }
      return res;
    }, formatDateADD(date) {
      function padZero(num) {
        return num < 10 ? '0' + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
  },
  mounted() {
    //获取搅拌站信息
    if (localStorage.sysOrgs) {
      this.orgList = JSON.parse(localStorage.sysOrgs);
    }
    /*获取出货单基础档案*/
    if (this.orgId == "") {
      if (localStorage.currentOrg) {
        this.orgId = JSON.parse(localStorage.currentOrg).Id;
        this.orgCode = JSON.parse(localStorage.currentOrg).OrgCode;
        this.orgName = JSON.parse(localStorage.currentOrg).Name;
        this.filters.orgCode = this.orgCode;
      } else if (this.orgList) {
        this.orgId = this.orgList[0].Id;
        this.orgCode = this.orgList[0].OrgCode;
        this.orgName = this.orgList[0].Name;
        this.filters.orgCode = this.orgCode;
      }
    }
    let pastDate = new Date(new Date().setHours(0, 0, 0, 0));
    pastDate.setDate(pastDate.getDate() - 365); //num正数为后一天，负数为前一天
    this.filters.startTime = this.formatDateADD(pastDate);

    let endDate = new Date(new Date().setHours(23, 59, 59, 0));
    endDate.setDate(endDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.endTime = this.formatDateADD(endDate);
    /*获取出货单基础档案*/
    this.getProdOutMaster();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getBaseData();
    this.getSysStationLineList(this.orgList[0].Id);
  },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}

.hr-select {
  width: 100px;
}

.table-value {
  color: #23ade5;
  margin-right: 20px;
}
</style>
